<!--
 Copyright (c) Qwoach LLC 2020. All rights reserved.
 Unauthorized copying of this file, via any medium is strictly prohibited
 Proprietary and confidential
 Created by Artem Bogush <artem@qwoach.com> on 8/25/20
-->

<script>
import BaseFormElement from "@/core/modules/coach/Resources/Forms/model/FormElements/BaseFormElement";
import {ViewModeEnum} from "@/utils/helpers";
import {debounce} from 'vue-debounce'
import BaseComponent from "@/core/components/BaseComponent.vue";
import FormItem from "@/core/modules/coach/Resources/Forms/model/FormItem.js";

export default {
	name: "BaseFormElementView",
	extends: BaseComponent,
	components: {},
	props: {
		formElement: BaseFormElement,
		viewMode: {type: String, default: "ANSWER"},
		formItem: FormItem,
	},

	data(){
		return {
			isInputDirty: false,
			inputDebounceDelay: 2000
		}
	},

	created(){
		this.inputChangedDebouncedInternal = debounce(this.inputChangedDebouncedInternal, this.inputDebounceDelay)
	},

	methods: {

		inputChangedDebounced(){
			console.log("inputChangedDebounced: this.isInputDirty = ", this.isInputDirty)
			this.isInputDirty = true
			this.inputChangedDebouncedInternal()
		},
		inputChangedDebouncedInternal(){
			console.log("inputChangedDebouncedInternal this.isInputDirty = ", this.isInputDirty)
			this.inputChanged()
		},
		inputChanged(){
			console.log("inputChanged: this.isInputDirty = ", this.isInputDirty)
			if(this.isInputDirty) {
				this.isInputDirty = false
				this.notifyElementChanged()
			}
		},



		onCopyClicked(){
			if(this.isEditMode && this.isEditable){
				this.$emit("copy", this.formElement)
			}
		},
		onDeleteClicked(){
			if(this.isEditMode && this.isEditable) {
				this.$emit("delete", this.formElement)
			}
		},

		switchScoringDirection(){
			this.formElement.isAutoScoreAscending = !this.formElement.isAutoScoreAscending
			this.scoringDirectionToggle()
		},

		scoringDirectionToggle(){
			if(this.isEditMode && this.isEditable) {
				this.recalculateScoring()
				this.notifyElementChanged()
			}
		},

		descriptionVisibilityToggle(){
			this.notifyElementChanged()
		},

		onRequiredChanged(){
			if(this.isEditMode && this.isEditable) {
				this.$emit("onRequiredChanged", this.formElement)
			}
		},

		onElementSelected(){
			if(this.isEditMode && !this.formElement._isSelected && this.isEditable){
				this.$emit("selected", this.formElement)
			}
		},

		onTypeChanged() {
			if(this.isEditMode && this.isEditable) {
				this.$emit("typeChanged", this.formElement)
			}
		},


		notifyElementChanged(){
			if(this.isEditMode && this.isEditable){
				this.$emit("change", this.formElement)
			}
		},

		recalculateScoring(){
			this.formElement.recalculateScoring()
		}



	},

	computed: {
		isSelected() {
			return this.isEditable && this.formElement._isSelected && this.isEditMode
		},

		isRequired() {
			return this.formElement.isRequired
		},

		isEditMode() {
			return this.viewMode === ViewModeEnum.EDIT// && !this.formElement.disableEditing
		},

		isViewMode() {
			return this.viewMode === ViewModeEnum.VIEW
		},

		isAnswerMode() {
			return this.viewMode === ViewModeEnum.ANSWER
		},

		isSpecialFormElement() {
			return this.formElement.isSpecialFormElement()
		},
		isEditable(){
			return this.$attrs.isEditable
		},
		iconScoringDirection() {
			return this.formElement.isAutoScoreAscending ?  "icon-sort-number-up" : "icon-sort-number-down"
		},
	}
}
</script>

<style lang="scss">
.form-element-root {

	.top-line {
		background-color: #409eff;
		height: 6px;
		border-top-left-radius: 3px;
		border-top-right-radius: 3px;
	}

	.is-selected {
		background-color: #409eff;
		width: 6px;
		border-top-left-radius: 3px;
		border-bottom-left-radius: 3px;
	}

	.horizontal-line, .horizontal-line-bottom {
		background-color: #409eff;
	}


	::-webkit-input-placeholder{
		font-weight: normal;
	}
	::-moz-placeholder{
		font-weight: normal;
	}
	:-ms-input-placeholder{
		font-weight: normal;
	}
	:-o-input-placeholder{
		font-weight: normal;
	}

	.dotted hr, hr.dotted {
		border-top-style: dotted;
	}

	.form-title{
		color: #6c757d;
		font-size: 14px;
		font-weight: 600 !important;

		input, textarea {
			font-size: 14px;
			font-weight: 600 !important;
		}
	}

	.form-description{
		input, textarea {
			font-size: 14px;
		}
	}

	.form-answer{
		input, textarea {
			font-size: 14px;
		}
	}
	.form-answer-edit{
		input, textarea {
			font-size: 14px;
		}
	}

}
</style>
